import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useReviews = (toolSlug) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReviews = useCallback(async () => {
    if (!toolSlug) return;
    try {
      const response = await axios.get(`${API}/reviews/${toolSlug}`);
      setReviews(response.data);
    } catch (error) {
      console.error('Failed to fetch reviews:', error);
      setReviews([]);
    } finally {
      setLoading(false);
    }
  }, [toolSlug]);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  const addReview = async (reviewData, token) => {
    const response = await axios.post(`${API}/reviews`, reviewData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setReviews(prev => [response.data, ...prev]);
    return response.data;
  };

  const updateReview = async (reviewId, reviewData, token) => {
    const response = await axios.put(`${API}/reviews/${reviewId}`, reviewData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setReviews(prev => prev.map(r => r.id === reviewId ? response.data : r));
    return response.data;
  };

  const deleteReview = async (reviewId, token) => {
    await axios.delete(`${API}/reviews/${reviewId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setReviews(prev => prev.filter(r => r.id !== reviewId));
  };

  return {
    reviews,
    loading,
    refetch: fetchReviews,
    addReview,
    updateReview,
    deleteReview,
  };
};
